import React, { memo, useEffect } from "react";
import { Slider, Stack } from "investira.react.components";

const RangeSlider = memo((props) => {
  const {
    label = "Label",
    minDistance = 1,
    onChange,
    sliderProps,
    defaultValue = [0, 100],
  } = props;

  function valuetext(value) {
    return `${value}%`;
  }

  const [value, setValue] = React.useState(defaultValue);

  const handleChange = (_pEvent, pNewValue, pActiveThumb) => {
    if (!Array.isArray(pNewValue)) {
      return;
    }

    if (pActiveThumb === 0) {
      setValue([Math.min(pNewValue[0], value[1] - minDistance), value[1]]);
    } else {
      setValue([value[0], Math.max(pNewValue[1], value[0] + minDistance)]);
    }
  };

  useEffect(() => {
    onChange && onChange(value);
  }, [value]);

  return (
    <Stack sx={{ mx: 2, my: 2 }}>
      <Slider
        label={label}
        getAriaLabel={() => label}
        value={value}
        onChange={handleChange}
        valueLabelDisplay="auto"
        getAriaValueText={valuetext}
        disableSwap
        {...sliderProps}
      />
    </Stack>
  );
});

export default RangeSlider;
